module.exports = __webpack_public_path__ + "static/media/search.2cd87025.svg";